var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _path, _path2, _path3, _path4, _line68, _line69, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFoodBoxFlexo = function SvgFoodBoxFlexo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300.0mm",
    height: "495.0mm",
    viewBox: "0.0 0.0 300.0 495.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    x2: 188,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 197,
    y1: 12,
    y2: 100,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 103,
    y1: 12,
    y2: 100,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 103,
    y1: 118.20000000000005,
    y2: 100,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    x2: 6,
    y1: 128,
    y2: 129,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 294,
    x2: 294,
    y1: 129,
    y2: 128,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 285,
    y1: 100,
    y2: 118.20000000000005,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 15,
    y1: 137,
    y2: 137,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 103,
    y1: 140,
    y2: 137,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 98.5,
    y1: 222.16666666666674,
    y2: 222.16666666666674,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 285,
    y1: 137,
    y2: 137,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 197,
    y1: 140,
    y2: 137,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 300,
    y1: 222.16666666666674,
    y2: 222.16666666666674,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 243,
    y2: 222.16666666666674,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 98.5,
    y1: 140,
    y2: 240,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 98.5,
    y1: 243,
    y2: 240,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 300,
    y1: 222.16666666666674,
    y2: 243,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 201.5,
    y1: 240,
    y2: 140,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 201.5,
    y1: 243,
    y2: 240,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 300,
    y1: 283,
    y2: 243,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 300,
    y1: 283,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 207.5,
    x2: 300,
    y1: 323,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 204.5,
    x2: 207.5,
    y1: 323,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 204.5,
    y1: 323,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 201.5,
    y1: 286,
    y2: 386,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 201.5,
    y1: 283,
    y2: 286,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 198.5,
    y1: 386,
    y2: 392,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 198.5,
    x2: 198.5,
    y1: 392,
    y2: 492,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 167.16666666666666,
    x2: 198.5,
    y1: 492,
    y2: 492,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 135.83333333333331,
    x2: 164.16666666666666,
    y1: 495,
    y2: 495,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 167.16666666666666,
    x2: 164.16666666666666,
    y1: 492,
    y2: 495,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 132.83333333333331,
    x2: 135.83333333333331,
    y1: 492,
    y2: 495,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 132.83333333333331,
    y1: 492,
    y2: 492,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 104.5,
    x2: 101.5,
    y1: 492,
    y2: 492,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 104.5,
    y1: 492,
    y2: 492,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 101.5,
    y1: 392,
    y2: 492,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 98.5,
    y1: 286,
    y2: 386,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 98.5,
    y1: 392,
    y2: 386,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 98.5,
    y1: 283,
    y2: 286,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 95.5,
    x2: 98.5,
    y1: 323,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    x2: 95.5,
    y1: 323,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 92.5,
    y1: 323,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 283,
    y2: 323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 243,
    y2: 283,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 132.83333333333331,
    x2: 167.16666666666666,
    y1: 280,
    y2: 280,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 167.16666666666666,
    x2: 132.83333333333331,
    y1: 286,
    y2: 286,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 140,
    y1: 386,
    y2: 392,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 386,
    y2: 392,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 140,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 140,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 160,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 197,
    y1: 100,
    y2: 137,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 103,
    y1: 100,
    y2: 137,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 201.5,
    y1: 240,
    y2: 240,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 98.5,
    y1: 140,
    y2: 140,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 200,
    y1: 243,
    y2: 243,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 200,
    y1: 283,
    y2: 243,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 200,
    y1: 283,
    y2: 283,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 167.16666666666666,
    y1: 286,
    y2: 286,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 132.83333333333331,
    y1: 286,
    y2: 286,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 100,
    y1: 283,
    y2: 283,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 140,
    y1: 386,
    y2: 386,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 140,
    y1: 392,
    y2: 392,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 201.5,
    x2: 160,
    y1: 386,
    y2: 386,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 198.5,
    x2: 160,
    y1: 392,
    y2: 392,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 100,
    y1: 243,
    y2: 283,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 100,
    y1: 243,
    y2: 243,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 140 386 c 0 -6 4 -10 10 -10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 160 386 c 0 -6 -4 -10 -10 -10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 140 392 c 0 6 4 10 10 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 160 392 c 0 6 -4 10 -10 10"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 167.16666666666666,
    x2: 167.16666666666666,
    y1: 286,
    y2: 280,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 132.83333333333331,
    x2: 132.83333333333331,
    y1: 280,
    y2: 286,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 119.3333 190 a 12.5 12.5 0 0 1 25 0 a 12.5 12.5 0 0 1 -25 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 152.6667 190 a 12.5 12.5 0 0 1 25 0 a 12.5 12.5 0 0 1 -25 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 140 100 c 0 -6 4 -10 10 -10"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 160 100 c 0 -6 -4 -10 -10 -10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 103 12 c 0 -12 9 -12 9 -12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 6 129 C 6 123.6 8.25 120.45 15 118.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 6 128 c 0 9 9 9 9 9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 197 12 c 0 -12 -9 -12 -9 -12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 294 129 C 294 123.6 291.75 120.45 285 118.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 294 128 c 0 9 -9 9 -9 9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoodBoxFlexo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/food-box-flexo.cf7f7e7b.svg";
export { ForwardRef as ReactComponent };